import { render } from "./HeroiconsSolidBookmarkAlt.vue?vue&type=template&id=a2aa916c"
const script = {}

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidBookmarkAlt.vue"]])

export default __exports__